import type { CommandItem } from './CommandPalette.types';

export class CommandRegistry {
  private readonly sourceCommands = new Map<string, Map<string, CommandItem>>();

  register(source: string, commands: CommandItem[]): () => void {
    const scopedCommands = new Map<string, CommandItem>();

    for (const command of commands) {
      scopedCommands.set(command.id, command);
    }

    this.sourceCommands.set(source, scopedCommands);

    return () => {
      this.sourceCommands.delete(source);
    };
  }

  getAll(): CommandItem[] {
    const merged = new Map<string, CommandItem>();

    for (const [, commandMap] of this.sourceCommands) {
      for (const [id, command] of commandMap) {
        if (merged.has(id)) {
          console.warn(`[CommandPalette] Duplicate command id detected: ${id}`);
        }
        merged.set(id, command);
      }
    }

    return Array.from(merged.values());
  }
}
